import _sfc_main from "./index.vue2.mjs";
/* empty css            */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "header-container" }, [_c("div", { staticClass: "left-container" }, [_c(_setup.SwitchTheme, { staticClass: "header-item" }), _c(_setup.LayoutControl, { staticClass: "header-item" }), _c(_setup.NetworkInfo, { staticClass: "header-item" })], 1), _c("div", { staticClass: "center-container" }, [_c(_setup.RoomInfo, { staticClass: "header-item" })], 1), _c("div", { staticClass: "right-container" }, [_c(_setup.Language, { directives: [{ name: "show", rawName: "v-show", value: _setup.showHeaderInfo, expression: "showHeaderInfo" }], staticClass: "header-item" })], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "acaf17b5"
);
const indexPC = __component__.exports;
export {
  indexPC as default
};
